// API Base URL - REQUIRED: Must be configured per environment
export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000'

// Landing URL - OPTIONAL: Where to redirect unauthenticated users
// Most apps can hardcode "/login" here instead of using env variable
// Only use env variable if login route differs between environments
export const LANDING_URL = import.meta.env.VITE_LANDING_URL || '/login'

// SSO Configuration (IBM Security Verify)
export const IBM_VERIFY_AUTHORIZE_URL =
  import.meta.env.VITE_IBM_VERIFY_AUTHORIZE_URL || ''
export const IBM_VERIFY_CLIENT_ID =
  import.meta.env.VITE_IBM_VERIFY_CLIENT_ID || ''
export const SSO_REDIRECT_URI =
  import.meta.env.VITE_SSO_REDIRECT_URI ||
  `${window.location.origin}/auth/callback`
